<template lang="html">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <busie-quote-card
          color="primary"
          title="Quotes"
          text="All Trips"
          :quotes="displayedQuotes">
          <template #filter>
            <busie-quote-filter
              :quotes="quotesWithStops"
              @filtered="applyFilter"
              @clear="removeFilter"/>
          </template>
        </busie-quote-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import QuoteFilter from '@/components/busie/QuoteFilter'
import QuoteCard from '@/components/busie/QuoteCard'
import { mapGetters } from 'vuex';

export default {
  components: {
    'busie-quote-filter': QuoteFilter,
    'busie-quote-card': QuoteCard
  },
  data: () => ({
    filteredData: [],
    activeFilter: false
  }),
  computed: {
    quotedTrips () {
      return this.getQuoted.filter(q => !q.trip.booked)
    },
    quotesWithStops () {
      const map = this.stopsByTripMap
      const quotedTrips = this.quotedTrips
      const result = []
      map.forEach((stops, tripId) => {
        let min = 0
        let max = this.quotedTrips.length - 1
        let guess;
        while (max >= min) {
          guess = Math.floor((max + min)/2)
          if (quotedTrips[guess].trip.id === tripId) {
            const quote = Object.assign({}, quotedTrips[guess]);
            quote.trip = Object.assign({}, quotedTrips[guess].trip);
            const pickup = Object.assign({}, stops[0])
            pickup.date = this.dateById(pickup.date).date
            const additionalStops = stops.slice(1, stops.length - 1).map(s => {
              const stop = Object.assign({}, s)
              stop.date = this.dateById(stop.date).date
              return stop
            })
            quote.trip.stops = { pickup, additionalStops }
            result.push(quote)
            return
          }
          if (tripId > quotedTrips[guess].trip.id) {
            min = guess + 1
          } else {
            max = guess - 1
          }
        }
      })
      return result
    },
    displayedQuotes () {
      return this.activeFilter ? this.filteredData : this.quotedTrips
    },
    ...mapGetters('quotes', [ 'getQuoted' ]),
    ...mapGetters('dates', { dateById: 'byId' }),
    ...mapGetters('stops', ['stopsByTripMap'])
  },
  methods: {
    applyFilter (data) {
      this.activeFilter = true
      this.filteredData = data
    },
    removeFilter () {
      this.activeFilter = false
      this.filteredData = []
    }
  }
}
</script>
